import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Container, Row, Col, Card, CardBody, Input, Label } from "reactstrap"
import Select from "react-select"
import { useNavigate } from "react-router-dom"
import ReportImg from "../../../assets/images/ReportImg.jpg"
import "../../../assets/css/Finance/Style/ReportsFinance.css"
import zithasLogo from "../../../assets/images/zithasLogo.png"

const StatementFormate = () => {
  return (
    <React.Fragment>
      <div className="page-content mb-4">
        <Container fluid>
          <Row>
            <Col md={12} className="p-0">
              <Card>
                <CardBody>
                  {/* <div
            id="salaryslip-export"
            className="container my-4 border border-dark border-3 px-2"
        >
            <div className="row border-bottom border-dark border-2 mb-3">
            <div className="col-12 text-center  py-2">
                <h1 className="text-primary">
                <img
                    src={zithasLogo}
                    alt="Company Logo"
                    height={55}
                />
                </h1>
            </div>
            </div>

            <div className="row  mb-3">
            <div className="col-12 text-center">
                <strong>
                FF-16, Kalpvrux Compex, Opp. GEB Substation,
                Gotri, Vadodara, Gujarat 390021
                </strong>
            </div>
            <input type="hidden" id="companyId" value="" />
            </div>

            <div className="row border-bottom border-dark border-2 mb-3 pb-2">
            <div className="col-12 text-center">
                <strong>Tel.:</strong> +91 7203882277
                &nbsp;&nbsp;&nbsp;
                <strong>E-mail :</strong> hr@zithas.com
                &nbsp;&nbsp;&nbsp;
                <strong>Website :</strong> www.zithas.com
            </div>
            </div>

            <div className="row border-bottom border-dark border-2 mb-3">
            <div className="col-12 text-center pb-2">
                Pay Slip for the Period of{" "}
                <strong>August - 2024</strong>
            </div>
            </div>

            <div className="row border-bottom border-dark border-2 mb-0">
            <div className="col-md-6">
                <div className="row">
                <div className="col-6 text-end">
                    <label>Employee Id</label>
                    <br />
                    <label>Department</label>
                    <br />
                    <label>Date Of Joining</label>
                    <br />
                    <label>Days Worked</label>
                    <br />
                    <label>Bank Acct/Cheque No</label>
                    <br />
                </div>
                <div className="col-6">
                    <label>: ZI-01</label>
                    <br />
                    <label>: Develpment</label>
                    <br />
                    <label>: 29/05/2024</label>
                    <br />
                    <label>: 0</label>
                    <br />
                    <label>: </label>
                    <br />
                </div>
                </div>
            </div>

            <div className="col-md-6">
                <div className="row">
                <div className="col-6 text-end">
                    <label>Name</label>
                    <br />
                    <label>Designation</label>
                    <br />
                    <label>Leaves</label>
                </div>
                <div className="col-6">
                    <label>
                    <strong>: Rahul Ovhal</strong>
                    </label>
                    <br />
                    <label>: React Developer</label>

                    <br />
                    <label>: 0</label>
                </div>
                </div>
            </div>
            </div>

            <div className="row border-bottom border-dark border-2 mb-0">
            <div className="col-md-6 border-end border-dark border-2 py-0">
                <div className="row">
                <div className="col-6 py-2">
                    <strong>Earnings</strong>
                </div>
                <div className="col-6 py-2 text-center">
                    <strong>Amount</strong>
                </div>
                </div>
            </div>
            <div className="col-md-6 ">
                <div className="row">
                <div className="col-6 py-2 ">
                    <strong>Deductions</strong>
                </div>
                <div className="col-6 py-2 text-center">
                    <strong>Amount</strong>
                </div>
                </div>
            </div>
            </div>

            <div className="row border-bottom mb-0">
            <div className="col-md-6 border-end border-dark border-2">
                <div className="row">
                <div className="col-6 py-2">
                    <label>Basic Pay</label>
                    <br />
                    <label>Dearness Allowance</label>
                    <br />
                    <label>Medical Allowance</label>
                    <br />
                    <label>House Rent Allowance</label>
                    <br />
                    <label>Conveyance Allowance</label>
                </div>
                <div className="col-6 text-center py-2">
                    <label>₹ 0.</label>
                    <br />
                    <label>₹ 0.00</label>
                    <br />
                    <label>₹ 0.00</label>
                    <br />
                    <label>₹ 0.00</label>
                    <br />
                    <label>₹ 0.00</label>
                </div>
                </div>
            </div>

            <div className="col-md-6">
                <div className="row">
                <div className="col-6 py-2">
                    <label>Employee State Insurance</label>
                    <br />
                    <label>Provident Fund</label>
                    <br />
                    <label>Professional Tax</label>
                    <br />
                    <label>Other Deduction</label>
                    <br />
                    <label>Punctual Deduction</label>
                </div>
                <div className="col-6 text-center py-2">
                    <label>₹ 0.00</label>
                    <br />
                    <label>₹ 0.00</label>
                    <br />
                    <label>₹ 0.00</label>
                    <br />
                    <label>₹ 0.00</label>
                    <br />
                    <label>₹ 0.00</label>
                </div>
                </div>
            </div>
            </div>

            <div className="row border-top border-dark border-2">
            <div className="col-md-6 border-end border-dark py-2">
                <strong>Total Earnings</strong>
            </div>
            <div className="col-md-6 text-end py-2 pe-3">
                <strong>₹ 0.00</strong>
            </div>
            </div>

            <div className="row border-top border-dark border-2">
            <div className="col-md-6 border-end border-dark py-2">
                <strong>Total Deductions</strong>
            </div>
            <div className="col-md-6 text-end py-2 pe-3">
                <strong>₹ 0.00</strong>
            </div>
            </div>

            <div className="row border-top border-dark border-2 ">
            <div className="col-md-6 border-end border-dark py-2">
                <strong>Net Pay (Rounded)</strong>
            </div>
            <div className="col-md-6 text-end py-2 pe-3">
                <strong>₹ 0.00</strong>
            </div>
            </div>

            <div className="row border-bottom border-dark border-2 ">
            <div className="col-md-6 small-section border-end border-dark py-2">
                <strong>Employer's Signature :</strong>
            </div>
            <div className="col-md-6 small-section py-2">
                <strong>Employee's Signature :</strong>
            </div>
            </div>

            <div className="row">
            <div className="col-12 text-center p-3">
                <strong>
                THIS IS A COMPUTER GENERATED SLIP, HENCE
                SIGNATURE IS NOT REQUIRED
                </strong>
            </div>
            </div>
        </div> */}
                  <div className="statement-wrapper">
                    <div className="statement-container" id="pdfmaker">
                      <div className="display-flex">
                        <div className="logo-container col-md-6">
                          <img src={zithasLogo} alt="Company Logo" />
                        </div>
                        <div className="address-right pt-3 col-md-4">
                          Zithas Technologies Pvt. Ltd. FF-16 Kalpvrux Complex,
                          Opp. GEB Substation, Gotri Road Vadodara Gujarat
                          390021 India GSTIN 24AAKCG1425E1Z1
                        </div>
                      </div>
                      <div className="row my-3 mt-4">
                        <hr className="col-md-4 border-secondary border-top" />
                        <h4 className="col-md-4 text-center">STATEMENT</h4>
                        <hr className="col-md-4 border-secondary border-top" />
                      </div>
                      <div className="row">
                        <p className="col-md-6">
                          <b>Customer Name :</b>{" "}
                          <span id="custName">Zithas Tech.</span>
                        </p>
                        <p className="col-md-6 text-end">
                          <b>Period :</b>{" "}
                          <span id="period">01-06-2023 To 31-08-2024</span>
                        </p>
                      </div>
                      <div className="items">
                        <table className="item_table  border-dark border-2">
                          <thead>
                            <tr>
                              <th className="text-center">Sr. No.</th>
                              <th>Date</th>
                              <th>Inv No.</th>
                              <th>Amount</th>
                              <th>Received</th>
                              <th>Remark</th>
                            </tr>
                          </thead>
                          <tbody id="stat-data">
                            <tr>
                              <td className="text-center">1</td>
                              <td>23-07-2024</td>
                              <td>PRF/2024-2025/0001</td>
                              <td>₹ 708</td>
                              <td>-</td>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td className="text-center">2</td>
                              <td>24-07-2024</td>
                              <td>PRF/2024-2025/0002</td>
                              <td>$ 1180</td>
                              <td>-</td>
                              <td>-</td>
                            </tr>
                            <tr>
                              <td className="text-center">3</td>
                              <td>25-07-2024</td>
                              <td>PRF/2024-2025/0004</td>
                              <td>$ 82.6</td>
                              <td>-</td>
                              <td>-</td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td>
                                <b></b>
                              </td>
                              <td>
                                <b></b>
                              </td>
                             
                              <td >
                                <b>Total</b>
                              </td>
                              <td>
                                <div className="currency-total">
                                  ₹ 708
                                  <br />
                                  $ 82.6
                                  <br />$ 1180
                                </div>
                              </td>
                              <td>
                                <div className="currency-total">
                                  ₹ 0<br />
                                  $ 0<br />$ 0
                                </div>
                              </td>
                              <td>
                                <div className="currency-total">
                                
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <b style={{ color: "red" }}></b>
                              </td>
                              <td>
                                <b style={{ color: "red" }}></b>
                              </td>
                              <td>
                                <b style={{ color: "red" }}></b>
                              </td>
                              <td >
                                <b style={{ color: "red" }}>Balance</b>
                              </td>
                              <td >
                                <div
                                  className="currency-total"
                                  style={{ color: "red" }}
                                >
                                  ₹ 708
                                  <br />
                                  $ 82.6
                                  <br />$ 1180
                                </div>
                              </td>
                              <td >
                                <b style={{ color: "red" }}></b>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default StatementFormate
